<div class="dialog-start-race dialog">

    <div mat-dialog-title>
        <h2>
            @if(raceAlreadyStarted) {
            Relancer la course
            } @else {
            Lancer une course
            }
        </h2>
        <h4>{{raceName}}</h4>
    </div>



    <mat-dialog-content>

        <div class="current-time">
            {{now$ | async | date: 'HH:mm:ss'}}
        </div>

        <form [formGroup]="raceTimingForm" class="form-wrapper">
            <mat-form-field appearance="outline">
                <mat-label>Type de départ</mat-label>
                <mat-select matInput formControlName="startType">
                    @for (type of startType; track $index) {
                    <mat-option [value]="type">
                        {{startTypeLabel(type)}}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-slide-toggle color="primary" [formControl]="differedTime">
                Lancer en différée
            </mat-slide-toggle>

            @if (differedTime.value) {
            <mat-form-field appearance="outline">
                <mat-label>Date et heure de départ</mat-label>
                <input matInput type="datetime-local" id="startDateTime" name="startTime"
                    formControlName="startDateTime" [max]="" class="form-control" step="1">
            </mat-form-field>
            <!-- <div class="input-group mb-3" style="max-width: 500px;">
                <span class="input-group-text" id="basic-addon1">Heure de départ</span>
                <input type="datetime-local" id="startDateTime" name="startDateTime" formControlName="startDateTime"
                    [ngClass]="{'is-valid': isInputValid(raceTimingForm.controls['startDateTime']), 'is-invalid': displayError(raceTimingForm.controls['startDateTime'])}"
                    [max]="" class="form-control" step="1">
            </div> -->
            }
        </form>
    </mat-dialog-content>

    <div mat-dialog-footer class="d-flex flex-row gap-2 justify-content-end">
        <button class="btn btn-danger" mat-dialog-close>Annuler</button>
        <button class="btn btn-success" (click)="start()">Lancer</button>
    </div>
</div>